var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-lg-5 col-xl-4"},[_c('NewForm')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }